// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const BookingStepOne = registerClientReference(
    function() { throw new Error("Attempted to call BookingStepOne() from the server but BookingStepOne is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/booking/BookingStepOne.tsx",
    "BookingStepOne",
);
